/* global axios */
import ApiClient from '../ApiClient';

// T-204: causa raiz x criticidade x sentimento. Recurso singular, como o Farol.
class CruzamentoAPI extends ApiClient {
  constructor() {
    super('fandata/cruzamento', { accountScoped: true });
  }

  // T-252: canal e lado, ambos opcionais.
  get({ since, until, inboxId, lado } = {}) {
    return axios.get(this.url, {
      params: { since, until, inbox_id: inboxId, lado },
    });
  }

  // As conversas por trás de uma linha (só `causa`) ou de uma célula (`causa` + `protocolo`).
  conversas({ causa, protocolo, since, until, inboxId, lado } = {}) {
    return axios.get(`${this.url}/conversas`, {
      params: { causa, protocolo, since, until, inbox_id: inboxId, lado },
    });
  }
}

export default new CruzamentoAPI();
